import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Modal from '@divvy-web/skylab.modal'

import ImageWrapper from '@sputnik/components/ImageWrapper'
import useDeviceDetect from '@sputnik/hooks/useDeviceDetect'

import styles from './styles.module.scss'

interface VerifyPhoneNumberModalViewProps {
  isShowing: boolean
  actionButtons: React.ReactNode
  title: React.ReactNode
  onClose: () => void
}

const VerifyPhoneNumberModalView = ({
  children,
  isShowing,
  title,
  actionButtons,
  onClose,
}: React.PropsWithChildren<VerifyPhoneNumberModalViewProps>) => {
  const { isMobile } = useDeviceDetect()
  const [getClassName] = useNameFormatter('VerifyPhoneNumberModalView')

  return (
    <Modal
      actions={<div className={styles[getClassName('buttons')]}>{actionButtons}</div>}
      className='dd-privacy-allow'
      headerColor='accent'
      headerImage={!isMobile ? <ImageWrapper imageName='signup-create-password-modal' /> : null}
      isShowing={isShowing}
      title={title}
      onCloseClick={onClose}
    >
      <div className={styles[getClassName('')]}>{children}</div>
    </Modal>
  )
}

export default VerifyPhoneNumberModalView
